import microModal from 'micromodal';
import { dateInTheFuture } from './date';

const AGE_COOKIE_NAME = 'acceptedAge';
const CUSTOMER_SEGMENT_COOKIE_NAME = 'isBusinessCustomer';
const MODAL_ID = 'age-consent-and-customer-segment-select-modal';
const ESC_KEY = 27;

const writeCustomerSegmentCookie = date => {
  const modal = document.querySelector(
    '#age-consent-and-customer-segment-select-modal',
  );
  const checkedSegmentSelect = modal.querySelector('input:checked');
  let isBusinessCustomer =
    checkedSegmentSelect && checkedSegmentSelect.value === 'true';

  document.cookie = `${CUSTOMER_SEGMENT_COOKIE_NAME}=${isBusinessCustomer}; path=/;expires=${date}`;
};

const writeAgeCookie = date => {
  document.cookie = `${AGE_COOKIE_NAME}=true; path=/;expires=${date}`;
};

const closeModal = () => {
  const date = dateInTheFuture();
  writeAgeCookie(date);
  writeCustomerSegmentCookie(date);
  location.reload();
};

const escListener = e => {
  var modal = document.querySelector(`#${MODAL_ID}[aria-hidden=false]`);
  if (modal && event.keyCode === ESC_KEY) {
    e.stopImmediatePropagation();
  }
};

export function init() {
  window.document.addEventListener('keydown', escListener);
  microModal.init();

  if (
    (document.cookie.indexOf(AGE_COOKIE_NAME) === -1 ||
      document.cookie.indexOf(CUSTOMER_SEGMENT_COOKIE_NAME) === -1) &&
    document.querySelector('body[data-requires-age-verification]')
  ) {
    microModal.show(MODAL_ID, {
      onClose: _ => closeModal(),
      disableScroll: true,
      debugMode: false,
    });
  }
}
